<template>
    <div class="w-full h-auto relative flex justify-center">
        <img src="../../assets/img/Mobile/back1.webp" alt="" class="w-full h-auto">
        <img src="../../assets/img/Mobile/MobileHome.webp" alt="" class="w-[95vw] h-auto absolute top-[2vw] left-[5vw]">
        <div class="w-[50vw] h-[50vw] bg-[#171717] absolute top-[88vw] rounded-full blur-[10vw]"></div>
        <div class="flex flex-col items-center absolute top-[80vw]">
             <img src="../../assets/img/Desktop/Home/IdleGlory.png" alt="" class="w-[75vw]">
             <p class="text-white text-[4.65vw] font-league mt-[3.5vw] font-medium">Awaken the Lengend within you!</p>
             <p class="text-white text-[3.25vw] font-league mt-[3.5vw] font-semibold text-center mx-[2.5vw]">The ultimate turn-based tactical Idle RPG: Where strategy and<br/>perseverance transform you into a legend.</p>
            <img src="../../assets/img/Mobile/EnterAerthospng.webp" alt="" class="w-[33vw] mt-[3.5vw]" @click="openWebLink('https://play.idle-glory.io/')">
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}
</style>